(function () {
    'use strict';

    angular
        .module('sod.helper')
        .directive('customDropdownButton', customDropdownButton);

    const template = `
        <div class="sod-dropdown-button" ng-class="{dark: vm.dark}">
            <div class=" button-group">
                <button type="button"
                        class="button default"
                        ng-bind-html="vm.quickButtonContent"
                        ng-if="vm.quickButtonContent"
                        ng-click="vm.quickButtonAction()"
                ></button>
                <button type="button"
                        class="button default toggle-trigger-button"
                        ng-click="vm.toggle()"
                        ng-bind-html="vm.buttonContent"
                >
                </button>
            </div>
            <div class="dropdown-wrapper" ng-show="vm.toggleState">
            <ul class="dropdown">
                <ng-transclude></ng-transclude>
            </ul>
            </div>
        </div>
    `;

    function customDropdownButton($document, lodash, customDropdownButtonService) {
        return {
            restrict: 'E',
            controller: customDropdownButtonCtrl,
            controllerAs: 'vm',
            bindToController: true,
            transclude: true,
            template: template,
            scope: {
                buttonContent: '=?',
                quickButtonContent: '=?',
                quickButtonAction: "&?"
            },
            link: customDropdownButtonLink
        };

        function customDropdownButtonLink(scope, elem, attr) {
            var vm = scope.vm;

            if (!vm.buttonContent) {
                vm.buttonContent = '<i class="fa fa-cog"></i>'
            }

            vm.dark = lodash.has(attr, 'dark');

            $document.on('click', function (e) {
                let buttonElem = angular.element(e.target);
                if (buttonElem.hasClass('toggle-trigger-button')) return;

                buttonElem = buttonElem.parents('.toggle-trigger-button');
                if (buttonElem.hasClass('toggle-trigger-button')) return;

                customDropdownButtonService.closeAll();
                scope.$apply();
                // if (vm.toggleState) {
                //     vm.toggle();
                //     scope.$apply();
                // }
            });

            // trigger when li is clicked;

            scope.$on('$destroy', function () {
                elem.off('click');
            });
        }
    }

    function customDropdownButtonCtrl(customDropdownButtonService, $scope, $element) {
        var vm = this;

        this.$onInit = function() {
            vm.toggleState = false;

            vm.toggle = toggle;
            vm.close = close;

            vm.currentServiceId = customDropdownButtonService.createReference({
                close: vm.close,
                toggle: vm.toggle
            });
        }

        function toggle() {
            customDropdownButtonService.closeAll();
            vm.toggleState = !vm.toggleState;
        }

        function close() {
            vm.toggleState = false;
        }

        $scope.$on('$destroy', function() {
            if (vm.currentServiceId !== null) {
                customDropdownButtonService.destroy(vm.currentServiceId);
            }
        })
    }
})();